// How the backend reports who ended a chat.
export var ChatEndedByType;
(function (ChatEndedByType) {
    ChatEndedByType[ChatEndedByType["Customer"] = 1] = "Customer";
    ChatEndedByType[ChatEndedByType["Agent"] = 2] = "Agent";
    ChatEndedByType[ChatEndedByType["System"] = 3] = "System";
})(ChatEndedByType || (ChatEndedByType = {}));
export default ChatEndedByType;
//# sourceMappingURL=chat-ended-by-type.js.map